<template>
  <div>
    <va-modal
      title="Modification d'une formation"
      class="modal activity"
      v-model="showCreateFormation"
      cancelClass="none"
      okText="Enregistrer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="saveFormation"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md8 pa-2">
                <va-select
                  label="Type de formation"
                  textBy="desc"
                  keyBy="idformation_types"
                  v-model="newFormation.type"
                  :options="formationTypes"
                />
              </div>
              <div class="flex md4 pa-2">
                <va-date-picker
                  label="Date de la formation"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="newFormation.date"
                />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12 pa-2">
                <va-checkbox
                  disabled
                  label="Inter-entreprise"
                  v-model="newFormation.inter"
                />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md8 pa-2">
                <va-select
                  label="Lieu de la formation"
                  searchable
                  textBy="desc"
                  keyBy="idformation_lieux"
                  v-model="newFormation.lieu"
                  :options="listeLieux"
                />
              </div>
              <div class="flex md4 pa-2">
                <va-button
                  class="create-button"
                  @click="showCreateLieux = true"
                  color="info"
                >
                  <va-icon
                    size="20px"
                    name="fa fa-plus"
                  />
                </va-button>
              </div>
              <div
                class="flex md12 pa-2"
                v-if="newFormation.lieu"
              >
                <p>
                  {{ newFormation.lieu.nom }} - {{ newFormation.lieu.adresse}} <span v-if="newFormation.lieu.complement"> - {{newFormation.lieu.complement}}</span></br>
                  {{ newFormation.lieu.code_postal }} - {{ newFormation.lieu.ville }} <span v-if="newFormation.lieu.cedex"> - Cedex {{newFormation.lieu.cedex}}</span>
                </p>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md8 pa-2">
                <va-select
                  label="Formateur"
                  searchable
                  textBy="desc"
                  keyBy="idformation_formateurs"
                  v-model="newFormation.formateur"
                  :options="listeFormateurs"
                />
              </div>
              <div class="flex md4 pa-2">
                <va-button
                  class="create-button"
                  @click="showCreateFormateurs = true"
                  color="info"
                >
                  <va-icon
                    size="20px"
                    name="fa fa-plus"
                  />
                </va-button>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12 pa-2">
                <va-input
                  label="Commentaires"
                  type="textarea"
                  autosize
                  :minRows="5"
                  v-model="newFormation.commentaires"
                />
              </div>

            </div>

          </div>
        </div>
      </div>
    </va-modal>
    <create-lieux v-model="showCreateLieux" />
    <create-formateur v-model="showCreateFormateurs" />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import createLieux from "./create-lieux.vue";
import createFormateur from "./create-formateur.vue";
import { get } from "lodash";

export default {
  props: ["value", "idformation"],
  components: {
    "create-lieux": createLieux,
    "create-formateur": createFormateur,
  },
  data() {
    return {
      showCreateFormation: false,
      saveMessage: "Enregistrer",
      formationTypes: [],
      listeLieux: [],
      listeFormateurs: [],
      showCreateLieux: false,
      showCreateFormateurs: false,
      newFormation: {
        date: moment().format("DD-MM-YYYY"),
        lieu: "",
        inter: true,
        type: "",
        formateur: "",
        commentaires: null,
      },


    };
  },
  mounted() {
    this.showCreateFormation = this.value;
    this.getFormationType();
    this.getListeLieux();
    this.getFormateurs();
  },
  watch: {
    showCreateFormateurs() {
      this.getFormateurs();
    },
    showCreateLieux() {
      this.getListeLieux();
    },
    value() {
      this.showCreateFormation = this.value;
      this.getFormation()
    },
  },
  methods: {

    closeModal() {
      this.$emit("input", false);
    },

    saveFormation() {
      if (this.newFormation.type) {

        let formation = {
          idformation: this.idformation,
          date: moment(this.newFormation.date, "DD-MM-YYYY").format("YYYY-MM-DD"),
          idtype: this.newFormation.type.idformation_types,
          idlieu: this.newFormation.lieu.idformation_lieux,
          idformateur: this.newFormation.formateur.idformation_formateurs,
          commentaires: this.newFormation.commentaires,
        };


        axios.put("/api/afpf/update-formation-base", formation)
          .then(response => {
            this.launchEpicmaxToast("Formation modifiée avec succès");
            this.$emit("update");
            this.closeModal();
          })
          .catch(() => {
            this.launchEpicmaxToast("Erreur lors de l'enregistrement de la formation");
          });
      } else {
        this.launchEpicmaxToast("Veuillez remplir tous les champs obligatoires");
      }
    },
    async getListeLieux() {
      try {
        const response = await axios.get("/api/afpf/liste-lieux");
        response.data.forEach(element => {
          element.desc = element.nom + " (" + element.code_postal + " - " + element.ville + ")";
        });
        this.$set(this, 'listeLieux', response.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération des lieux");
      }
    },
    async getFormationType() {
      try {
        const response = await axios.get("/api/afpf/formation-type");
        response.data.forEach(element => {
          element.desc = element.name + " (" + element.shortname + ")";
        });
        this.$set(this, 'formationTypes', response.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération des types de formation");
      }

    },
    async getFormateurs() {
      try {
        const response = await axios.get("/api/afpf/liste-formateurs");
        response.data.forEach(element => {
          element.desc = element.titre + " " + element.nom + " " + element.prenom;
        });
        this.$set(this, 'listeFormateurs', response.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération des formateurs");
      }
    },
    async getFormation() {
      try {
        const response = await axios.get("/api/afpf/formation/", {
          params: {
            idformation: this.idformation,
          },
        });
        let formation = response.data;
        this.newFormation.date = moment(formation.date).format("DD-MM-YYYY");
        this.newFormation.type = this.formationTypes.find(type => type.idformation_types === formation.idtype) || "";
        this.newFormation.lieu = this.listeLieux.find(lieu => lieu.idformation_lieux === formation.idlieu) || "";
        this.newFormation.inter = formation.inter === 1;
        this.newFormation.formateur = this.listeFormateurs.find(formateur => formateur.idformation_formateurs === formation.idformateur) || "";
        this.newFormation.commentaires = formation.commentaires;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération des informations de la formation");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },

  },
}
</script>

<style scoped>
.forcewidth {
  width: 40vw;
  height: 60vh;
  overflow: auto;
}
</style>